import {VGNav} from "vgnav";
import VGSidebar from "vgnav/src/VGSidebar/js/VGSidebar";
import {VGLawCookie} from "vglawcookie";
import ar from "@fancyapps/ui/src/Fancybox/l10n/ar";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));

		// [vegas]
		VG.log();
		VG.clickToTab();
		VG.scrollToSection();
		VG.clones();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
	},

	onResize: ($self) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	clones: function () {
		if (window.innerWidth <= 991) {
			let $obj_filters_clone = $('.catalog-categories-clone');
			if ($obj_filters_clone.length) {
				$obj_filters_clone.clone(true).detach();
				$('.catalog-categories-clone-container').append($obj_filters_clone)
			}
		}
	},

	clickToTab() {
		const navigation = document.querySelectorAll('.main-tabs');
		if (!navigation) return;
		let prevIndex = null;
		let prevEl = null;

		navigation.forEach((el) => {
			const tabs = el.querySelectorAll('.nav-link');
			if(!tabs) return;

			tabs.forEach((el, index, arr) => {
				prevIndex = 0;
				prevEl = index === 0 ? el : arr[0];
				el.onclick = (e) => {
					if (e.target.tagName !== 'BUTTON') return;
					if(index > prevIndex) {
						if(prevEl.classList.contains('right')) {
							prevEl.classList.remove('right');
							prevEl.classList.add('left');
						}
						if(el.classList.contains('right')) {
							el.classList.remove('right');
							el.classList.add('left');
						}
						el.classList.add('left');
						prevIndex = index;
						prevEl = el;
					} else {
						el.classList.add('right');
						if(prevEl.classList.contains('left')) {
							prevEl.classList.remove('left');
							prevEl.classList.add('right');
						}
						prevIndex = index;
						prevEl = el;
					}
				}
			})
		});
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] > img').each(function(){
				$(this).closest('a').attr('href', $(this).attr('src'));
			});

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'lg',
				toggle: false
			});
		},

		enableAOS: function ()  {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableNiceSelect: function ()  {
			//$('.nice-select').niceSelect();
		},

		enableLawCookie: function () {
			new VGLawCookie();
		}
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	scrollToSection: () => {
		const link = document.querySelectorAll('[data-scroll-to-section]');
		const header = document.querySelector('.header-wrapper');
		const hash = window.location.hash;

		const scroller = (section, event) => {
			if(!section) return;
			if(event) event.preventDefault();

			console.log(section.getBoundingClientRect().y + window.scrollY);

			setTimeout(() => {
				scrollTo({
					behavior: "smooth",
					top: section.getBoundingClientRect().y + window.scrollY - header.clientHeight
				})
			}, 200)
		};

		const getSection = (element) => {
			let path = element.href;

			if(!path) {
				let attr = element.getAttribute('data-scroll-to-section');
				if(attr) {
					path = attr
				} else {
					return ;
				}
			}

			let id = path.slice(path.indexOf('#'));

			let section = document.querySelector(id);

			if (!section) {
				console.log('а к чему скролить то ???');
				return
			}
			return section;
		};

		if(hash) {
			let section = document.querySelector(hash);
			setTimeout(function () {
				scroller(section);
			}, 300);
		}

		[...link]
			.forEach(el => {
				el.addEventListener('click', (e) => {
					scroller(getSection(el), e)
				})
			})
	},
}


export default VGListener;
